(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-hot-reload')) {
    class ProductHotReload extends HTMLElement {
      constructor() {
        super();
        this.cache = new Map();
        this.activeRequests = new Map();
        this.loadingTimeout = null;
        this.supportsViewTransitions = 'startViewTransition' in document;
        this.hasInitializedOnConnect = false;
        this.initializationTimer = null;
        
        this.addEventListener('change', (event) => this.onVariantChange(event));
        this.addEventListener('mouseover', (event) => this.onMouseOver(event));
      }

      connectedCallback() {
        if (this.hasInitializedOnConnect) return;

        this.hasInitializedOnConnect = true;

        const initializeMedia = () => {
          if (this.initializationTimer) {
            clearTimeout(this.initializationTimer);
          }

          this.initializationTimer = setTimeout(() => {
            this.reinitializeImageSlider();
            this.reinitializeImageZoom();
            this.initializationTimer = null;
          }, 0);
        };

        if (document.readyState === 'loading') {
          document.addEventListener('page:loaded', initializeMedia, { once: true });
          return;
        }

        initializeMedia();
      }

      disconnectedCallback() {
        if (this.initializationTimer) {
          clearTimeout(this.initializationTimer);
          this.initializationTimer = null;
        }
      }

      showLoadingState() {
        this.loadingTimeout = setTimeout(() => {
          this.classList.add('product-hot-reload--loading');
        }, 200);
      }

      hideLoadingState() {
        if (this.loadingTimeout) {
          clearTimeout(this.loadingTimeout);
          this.loadingTimeout = null;
        }
        this.classList.remove('product-hot-reload--loading');
      }

      buildRequestUrl(input) {
        const sectionId = this.dataset.sectionId;
        
        // Get dataset values from the input or selected option
        let newProductUrl, optionValueId;
        
        if (input.type === 'radio') {
          newProductUrl = input.dataset.productUrl;
          optionValueId = input.dataset.optionValueId;
        } else if (input.tagName === 'SELECT') {
          const selectedOption = input.options[input.selectedIndex];
          newProductUrl = selectedOption.dataset.productUrl;
          optionValueId = selectedOption.dataset.optionValueId;
        }

        if (!newProductUrl || !optionValueId) {
          return null;
        }

        // Get all currently selected values from both radio inputs and select elements
        let selectedOptionValues = [];
        
        // Get values from checked radio inputs
        const checkedRadios = Array.from(this.querySelectorAll('input[type="radio"]:checked[data-option-value-id]'));
        selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
        
        // Get values from select elements
        const selects = Array.from(this.querySelectorAll('select[data-variant-input]'));
        selects.forEach(select => {
          const selectedOption = select.options[select.selectedIndex];
          if (selectedOption && selectedOption.dataset.optionValueId) {
            selectedOptionValues.push(selectedOption.dataset.optionValueId);
          }
        });

        // If we're building for a hover state, replace the current option's value
        if (input.type === 'radio' && !input.checked) {
          const currentOptionName = input.name;
          // Remove any existing selection for this option
          selectedOptionValues = selectedOptionValues.filter(id => {
            const foundInput = this.querySelector(`input[data-option-value-id="${id}"]`);
            return foundInput && foundInput.name !== currentOptionName;
          });
          // Add the hovered option value
          selectedOptionValues.push(optionValueId);
        }

        const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
        const finalUrl = `${newProductUrl}?section_id=${sectionId}${params}`;
        return finalUrl;
      }

      onMouseOver(event) {
        const label = event.target.closest('label');
        if (!label) return;

        // Find the input - it can be either inside the label or a sibling (using for/id)
        let input = label.querySelector('input[type="radio"][data-product-hot-reload-trigger]');
        
        if (!input && label.hasAttribute('for')) {
          const inputId = label.getAttribute('for');
          const escapedId = CSS.escape(inputId);
          input = this.querySelector(`#${escapedId}[data-product-hot-reload-trigger]`);
        }
        
        if (!input || input.checked) return;

        const requestUrl = this.buildRequestUrl(input);
        if (!requestUrl || this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

        this.fetchContent(requestUrl);
      }

      fetchContent(requestUrl) {
        const fetchPromise = fetch(requestUrl)
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.cache.set(requestUrl, html);
            this.activeRequests.delete(requestUrl);
            return html;
          })
          .catch(error => {
            this.activeRequests.delete(requestUrl);
            throw error;
          });

        this.activeRequests.set(requestUrl, fetchPromise);
        return fetchPromise;
      }

      async onVariantChange(event) {
        if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

        event.preventDefault();
        event.stopPropagation();

        const requestUrl = this.buildRequestUrl(event.target);
        if (!requestUrl) return;

        const productUrl = this.dataset.productUrl;
        this.showLoadingState();

        try {
          let html;
          if (this.cache.has(requestUrl)) {
            html = this.cache.get(requestUrl);
          } else if (this.activeRequests.has(requestUrl)) {
            html = await this.activeRequests.get(requestUrl);
          } else {
            html = await this.fetchContent(requestUrl);
          }

          await this.updateProductWithTransition(html, productUrl, event.target.id);
        } catch (error) {
          console.error('Error updating product content:', error);
        } finally {
          this.hideLoadingState();
        }
      }

      async updateProductWithTransition(html, productUrl, targetId) {
        let updatedHtml = html.getElementById(this.id);
        
        if (!updatedHtml) {
          updatedHtml = html.querySelector('product-hot-reload');
        }
        
        if (!updatedHtml) {
          console.error('Could not find updated product-hot-reload element');
          return;
        }
              
        if (this.supportsViewTransitions) {
          const transition = document.startViewTransition(() => {
            this.innerHTML = updatedHtml.innerHTML;
            this.dataset.productUrl = updatedHtml.dataset.productUrl;
            this.dataset.variantId = updatedHtml.dataset.variantId;
          });
          await transition.finished;
        } else {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        }

        this.reinitializeImageSlider();
        this.reinitializeImageZoom();
        this.reinitializeCollapsibles();
        this.reinitializePaymentButton();
        this.updateMasterSelect();
        this.updateBrowserHistory(productUrl);
        
        // Dispatch event for theme.js to reinitialize
        const productId = this.querySelector('[data-product-id]')?.dataset.productId;
        if (productId) {
          document.dispatchEvent(new CustomEvent('hotreload:updated', {
            detail: { productId: productId.toString() }
          }));
        }

        // Focus the changed input
        if (targetId) {
          try {
            const escapedId = CSS.escape(targetId);
            const targetElement = this.querySelector(`#${escapedId}`);
            if (targetElement) {
              targetElement.focus();
            }
          } catch (error) {
            console.warn('Could not focus target element:', targetId, error);
          }
        }
      }

      reinitializeImageSlider() {
        const sliderContainer = this.querySelector('[data-product-photos]');
        if (!sliderContainer) return;

        const thumbSlider = this.querySelector('[data-product-thumbs]');
        const thumbScroller = this.querySelector('.product__thumbs--scroller');

        const slides = sliderContainer.querySelectorAll('.product-main-slide');

        if (slides.length <= 1) {
          if (slides[0]) {
            slides[0].classList.add('is-selected');
          }
          return;
        }

        let startingIndex = 0;
        slides.forEach((slide, index) => {
          if (slide.classList.contains('starting-slide')) {
            startingIndex = index;
          }
        });

        const existingInstance = window.Flickity && window.Flickity.data(sliderContainer);
        if (existingInstance) {
          existingInstance.resize();
          return;
        }

        const sliderArgs = {
          adaptiveHeight: true,
          avoidReflow: true,
          childNav: thumbSlider,
          childNavScroller: thumbScroller,
          childVertical: sliderContainer.dataset.thumbPosition === 'beside',
          contain: true,
          dragThreshold: 25,
          fade: false,
          friction: 0.8,
          initialIndex: startingIndex,
          pageDots: false,
          prevNextButtons: sliderContainer.dataset.arrows === 'true',
          rightToLeft: theme.config.rtl,
          setGallerySize: true,
          wrapAround: true
        };

        if (window.theme && window.theme.Slideshow) {
          try {
            new theme.Slideshow(sliderContainer, sliderArgs);
          } catch (error) {
            console.error('Error creating Flickity:', error);
          }
        }
      }

      reinitializeImageZoom() {
        const imageContainer = this.querySelector('[data-product-images]');
        if (!imageContainer || imageContainer.dataset.zoom === 'false') return;

        const productSection = this.querySelector('[data-section-type="product"]');
        if (!productSection) return;

        const sectionId = productSection.dataset.sectionId;

        if (window.theme && window.theme.Photoswipe) {
          try {
            new theme.Photoswipe(imageContainer, sectionId);
          } catch (error) {
            console.error('Error initializing Photoswipe:', error);
          }
        }
      }

      reinitializeCollapsibles() {
        if (window.theme && window.theme.collapsibles && typeof theme.collapsibles.init === 'function') {
          try {
            theme.collapsibles.init(this);
          } catch (error) {
            console.error('Error reinitializing collapsibles:', error);
          }
        }
      }

      reinitializePaymentButton() {
        const paymentButtons = this.querySelector('.payment-buttons');
        if (!paymentButtons) return;
        
        const updateButtonText = () => {
          const unbrandedButton = this.querySelector('.shopify-payment-button__button--unbranded');
          if (unbrandedButton && unbrandedButton.textContent !== '구매하기') {
            unbrandedButton.textContent = '구매하기';
          }
          paymentButtons.classList.remove('payment-buttons-loading');
        };
        
        // Update immediately
        updateButtonText();
        
        // Also observe for changes (in case button loads after hot-reload)
        const observer = new MutationObserver(updateButtonText);
        observer.observe(paymentButtons, { childList: true });
        
        // Disconnect after 2 seconds to avoid memory leaks
        setTimeout(() => observer.disconnect(), 2000);
      }

      updateMasterSelect() {
        const variantId = this.dataset.variantId;
        if (!variantId) return;

        const masterSelect = this.querySelector('select[name="id"][data-product-select]');
        if (!masterSelect) return;

        masterSelect.value = variantId;
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      updateBrowserHistory(productUrl) {
        const variantId = this.dataset.variantId;
        const url = new URL(productUrl, window.location.origin);
        const currentUrl = new URL(window.location.href);
        
        // Preserve existing params except variant
        for (const [key, value] of currentUrl.searchParams.entries()) {
          if (key !== 'variant') {
            url.searchParams.set(key, value);
          }
        }
        
        if (variantId) {
          url.searchParams.set('variant', variantId);
        }
        
        window.history.pushState({}, '', url.toString());
      }
    }

    customElements.define('product-hot-reload', ProductHotReload);
  }
  } catch(e) { console.error(e); }
})();

})();
